import { IUpdateCentroCustoSecundarioUseCase } from "../../../presentation/useCases/update/update_centro_custo_secundario_use_case";
import {  ITerceirizacaoRepository } from "../../repositories/terceirizacao_repository";

// UpdateEnderecoUseCase


export class UpdateCentroCustoSecundarioUseCase implements IUpdateCentroCustoSecundarioUseCase
 {
  constructor(private readonly repository: ITerceirizacaoRepository) {}

  async updateCentroCustoSecundario(
    idFuncionarioCentroCusto: number,
    idCentroCusto: number,
  ): Promise<void> {
    await this.repository.updateCentroCustoSecundario(idFuncionarioCentroCusto, idCentroCusto );
  }
}
